import { createSelector } from 'reselect'

const getMyLibrary = state => state.myLibrary

const myLibraryFolderSelector = createSelector(
	[getMyLibrary],
	myLibrary => ({
		folders: myLibrary.folders,
	})
)

export default myLibraryFolderSelector
